import AuthKit from "./AuthKit";

export default class {
  constructor() {
    this.authKit = new AuthKit();
    this.url = "/clickstream/"
  }

  async createStream(event_slug, path) {
    const uri = `${this.url}stream/`;
    const payload = {
      event_slug: event_slug,
      url: path
    }
    const response = await this.authKit.doPost(uri, payload);
    return response.data;
  }
}
